function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { grayscale, orange, blue, yellow, red, green } from '../Colors';
export var AgrofyTheme = {
  colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grayscale), orange), blue), yellow), red), green), {}, {
    // Black & White
    white: '#FFFFFF',
    black: '#0B0D1D',
    // Uses
    info: blue.info,
    primary: green.primary,
    danger: red.danger,
    warning: yellow.warning,
    pending: orange.pending,
    links: blue.links,
    infoHover: blue.infoHover,
    // Backgrounds
    // Light
    infoLight: blue.infoLight,
    warningLight: yellow.warningLight,
    dangerLight: red.dangerLight,
    pendingLight: orange.pendingLight,
    successLight: green.primaryLight,
    // Dark
    infoDark: blue.infoDark,
    warningDark: yellow.warningDark,
    dangerDark: red.dangerDark,
    successDark: green.primaryDark,
    pendingDark: orange.pendingDark
  }),
  fontFamily: "'Montserrat', sans-serif",
  breakpoint: {
    xxs: '320px',
    xs: '425px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    x: '1024px',
    xl: '1200px'
  }
};